import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetQuizDetailSlice = createSlice({
    name: "getQuizDetails",
    initialState,
    reducers: {
        getQuizDetailRequest(state) {
            state.loading = true;
        },
        getQuizDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getQuizDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getQuizDetailRequest,
    getQuizDetailRequestSuccess,
    getQuizDetailRequestError,
} = GetQuizDetailSlice.actions;

export default GetQuizDetailSlice.reducer;
